import React, { useState, useEffect } from 'react';
import axios from 'axios';
import FramedAvatar from './FramedAvatar';

const LiveHostsBar = ({ frameUrl, frameFit, barColor }) => {
  const [liveHosts, setLiveHosts] = useState({ show_bar: false, hosts: [] });

  useEffect(() => {
    loadLiveHosts();
    const interval = setInterval(loadLiveHosts, 30000); // Atualiza a cada 30 segundos
    return () => clearInterval(interval);
  }, []);

  const loadLiveHosts = async () => {
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.get(`${BACKEND_URL}/api/agency/live-hosts-with-links`);
      setLiveHosts(response.data);
    } catch (error) {
      console.error('Erro ao carregar hosts ao vivo:', error);
      setLiveHosts({ show_bar: false, hosts: [] });
    }
  };

  if (!liveHosts.show_bar || liveHosts.hosts.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-r from-purple-600 via-purple-500 to-blue-600 text-white py-2 overflow-hidden shadow-lg"
         style={barColor ? { background: barColor } : undefined}
         data-testid="live-hosts-bar">
      {barColor && barColor.includes('gradient') && <div className="bar-light-sweep" />}
      <div className="flex items-center gap-6 px-4 overflow-x-auto scrollbar-hide" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
        {liveHosts.hosts.map((host) => (
          <a
            key={host.show_id}
            href={host.live_link}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center gap-0.5 hover:scale-105 transition-transform cursor-pointer group"
          >
            {/* Avatar com moldura (tema ativo) ou moldura roxa padrão */}
            <div className="relative mt-1">
              {frameUrl ? (
                <div className="relative" data-testid={`live-host-framed-${host.show_id}`}>
                  <FramedAvatar src={host.avatar} frameUrl={frameUrl} fit={frameFit} size={84} />
                  {/* Barras de som (equalizer) sobre a foto */}
                  <div className="absolute left-1/2 -translate-x-1/2 flex items-end gap-0.5 bg-purple-900/80 rounded-full px-1.5 py-0.5 z-10" style={{ bottom: '16px' }}>
                    <div className="w-0.5 h-1.5 bg-white rounded-full animate-pulse"></div>
                    <div className="w-0.5 h-2 bg-white rounded-full animate-pulse" style={{animationDelay: '0.1s'}}></div>
                    <div className="w-0.5 h-1.5 bg-white rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
                    <div className="w-0.5 h-2 bg-white rounded-full animate-pulse" style={{animationDelay: '0.3s'}}></div>
                    <div className="w-0.5 h-1.5 bg-white rounded-full animate-pulse" style={{animationDelay: '0.4s'}}></div>
                  </div>
                </div>
              ) : (
              <div className="relative w-14 h-14 rounded-full bg-gradient-to-br from-purple-500 via-pink-500 to-purple-600 p-0.5 shadow-lg">
                {/* Avatar */}
                <img
                  src={host.avatar}
                  alt={host.nickname}
                  className="w-full h-full rounded-full object-cover border-2 border-white"
                />
                
                {/* Barras de som (equalizer) na parte inferior */}
                <div className="absolute bottom-0.5 left-1/2 -translate-x-1/2 flex items-end gap-0.5 bg-purple-900/80 rounded-full px-1.5 py-0.5">
                  <div className="w-0.5 h-1.5 bg-white rounded-full animate-pulse"></div>
                  <div className="w-0.5 h-2 bg-white rounded-full animate-pulse" style={{animationDelay: '0.1s'}}></div>
                  <div className="w-0.5 h-1.5 bg-white rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
                  <div className="w-0.5 h-2 bg-white rounded-full animate-pulse" style={{animationDelay: '0.3s'}}></div>
                  <div className="w-0.5 h-1.5 bg-white rounded-full animate-pulse" style={{animationDelay: '0.4s'}}></div>
                </div>
              </div>
              )}
            </div>
            
            {/* Nickname abaixo do avatar */}
            <p className="text-[9px] font-bold text-white text-center max-w-[70px] truncate group-hover:text-purple-100 transition-colors leading-tight">
              {host.nickname}
            </p>
          </a>
        ))}
      </div>
    </div>
  );
};

export default LiveHostsBar;
